export const environment = {
  isProduction: false,
  basePath: 'https://dev.backend.sanactivo.com/api/v1/tp',
  basePathAuthentication: 'https://dev.backend.sanactivo.com/api/v1/user/authentication',
  enableStateLogging: true,
  environmentName: 'development'
};
